import store from "@/store"
import defaultState from "@/store/state"

const APP_NAME = "cobrecom-portal-corporativo"

export default class AppLocalStorage {

  static checkStorage() {

    if (!localStorage[APP_NAME]) {
      const newStorage = { user: null, authToken: null, uploadToken: null }
      localStorage[APP_NAME] = JSON.stringify(newStorage)
    }      
  }

  static checkStore() {

    if (store.state.user)
      return

    AppLocalStorage.checkStorage()

    store.commit("setUser", AppLocalStorage.get("user"))
    store.commit("setAuthToken", AppLocalStorage.get("authToken"))  
    store.commit("setUploadToken", AppLocalStorage.get("uploadToken"))

    return store
  }

  static set(prop, value, storeMutation) {

    AppLocalStorage.checkStorage()

    let storage = JSON.parse(localStorage[APP_NAME])

    storage[prop] = value

    localStorage[APP_NAME] = JSON.stringify(storage)

    if (storeMutation)
      store.commit(storeMutation, value)
  }

  static get(prop) {

    AppLocalStorage.checkStorage()

    const storage = JSON.parse(localStorage[APP_NAME])

    return storage[prop]
  }

  static clear() {    

    store.replaceState(defaultState)

    localStorage.removeItem(APP_NAME)
  }

}
